// import Board from "componentsv2/board/Board";
import FinancialReports from "./FinancialReports";
// import { layoutParty } from "./Party";
// import { useGlobal } from "storev2/globalStore";
// import HelpDesk from "./HelpDesk";
// import { message, message2 } from "./helpdeskInfo";

function FinancialScreen() {
  // const layout = layoutParty();
  // const { loadData } = useGlobal();

  // useEffect(() => {
  //   // async function setData() {
  //   //   await loadData();
  //   // }
  //   // setData();
  // }, []);

  return (
    <div className="flex w-full">
      <FinancialReports style="w-2/3" />
    </div>
  );
}

export default FinancialScreen;
